const automaticReports = require('../automaticReports')
const { convertFromUTC, isClientSide, convertFromLocal } = require('./utils')

async function getRoute (traccar, from, to, devices) {
  const devicesToSlice = devices.slice()

  const arrayOfArrays = automaticReports.sliceArray(devicesToSlice, 50)
  let requests = []
  for (const a of arrayOfArrays) {
    const promise = traccar.reports.reportsRouteGet(from, to, a.map(d => d.id))
    requests = requests.concat(promise)
  }

  const result = await Promise.all(requests)
  return result.map(r => r.data).flat()
}

async function getTrips (traccar, from, to, devices) {
  const devicesToSlice = devices.slice()
  const arrayOfArrays = automaticReports.sliceArray(devicesToSlice, 50)
  let requests = []
  for (const a of arrayOfArrays) {
    const promise = traccar.reports.reportsTripsGet(from, to, a.map(d => d.id))
    requests = requests.concat(promise)
  }

  const result = await Promise.all(requests)
  return result.map(r => r.data).flat()
}

async function getStops (traccar, from, to, devices) {
  const devicesToSlice = devices.slice()
  const arrayOfArrays = automaticReports.sliceArray(devicesToSlice, 50)
  let requests = []
  for (const a of arrayOfArrays) {
    const promise = traccar.reports.reportsStopsGet(from, to, a.map(d => d.id))
    requests = requests.concat(promise)
  }

  const result = await Promise.all(requests)
  return result.map(r => r.data).flat()
}

async function getEvents (traccar, from, to, devices, events) {
  const devicesToSlice = devices.slice()
  const arrayOfArrays = automaticReports.sliceArray(devicesToSlice, 50)
  let requests = []
  for (const a of arrayOfArrays) {
    const promise = traccar.reports.reportsEventsGet(from, to, a.map(d => d.id), null, events)
    requests = requests.concat(promise)
  }
  const result = await Promise.all(requests)
  return result.map(r => r.data).flat()
}

async function getSummary (traccar, from, to, devices) {
  const devicesToSlice = devices.slice()
  const arrayOfArrays = automaticReports.sliceArray(devicesToSlice, 50)
  let requests = []
  for (const a of arrayOfArrays) {
    const promise = getAllInOne(traccar, from, to, a, false, false, false, true, 0, a.length, a.length, a.length, undefined, true)
    requests = requests.concat(promise)
  }

  const result = await Promise.all(requests)
  return result.map(r => r.summary).flat()
}

async function getAllInOne (
  traccar,
  from,
  to,
  devices,
  getRoutes,
  getTrips,
  getStops,
  getSummary,
  currentDeviceCount = 0,
  totalDevices = devices.length,
  sliceSize = 5,
  devicesPerRequest = 1,
  counter = undefined,
  ignorePercentage = false) {
  let url = `/reports/allinone?from=${from.toISOString()}&to=${to.toISOString()}`
  if (getRoutes) url += '&type=route'
  if (getTrips) url += '&type=trips'
  if (getStops) url += '&type=stops'
  if (getSummary) url += '&type=summary'

  const sliced = automaticReports.sliceArray(devices, sliceSize)
  const result = []
  for (const chunk of sliced) {
    const requests = []
    for (const _chunk of automaticReports.sliceArray(chunk, devicesPerRequest)) {
      const u = url + '&' + _chunk.map(d => `deviceId=${d.id}`).join('&')
      console.log(u)
      requests.push(
        traccar.axios.get(u, {
          jar: traccar.cookieJar,
          withCredentials: true,
          timeout: 900000
        }).then(r => r.data).then(x => {
          console.log('LOADING_MESSAGE:' + _chunk[0].name)
          if (counter) {
            counter.count += devicesPerRequest
            ignorePercentage || console.log(`PROGRESS_PERC:${counter.count / totalDevices * 100}`)
          } else {
            currentDeviceCount += devicesPerRequest
            ignorePercentage || console.log(`PROGRESS_PERC:${currentDeviceCount / totalDevices * 100}`)
          }
          console.log(_chunk.map(d => `deviceId=${d.id}`), x.route && x.route.length)
          return x
        }))
    }
    const now = new Date()
    console.log('parallel', requests.length)
    try {
      result.push(...(await Promise.all(requests)))
    } catch (e) {
      console.log(e)
    }
    console.log('took', new Date() - now, 'ms')
  }
  return {
    route: result.filter(t => t.route).map(r => r.route).flat(),
    trips: result.filter(t => t.trips).map(r => r.trips).flat(),
    stops: result.filter(t => t.stops).map(r => r.stops).flat(),
    summary: result.filter(t => t.summary).map(r => r.summary).flat()
  }
}

async function getSummaryByDay (dates, userData, traccarInstance, allDevices, ignorePercentage = false, from, to) {
  const days = []
  let counter = 0
  for (const [index, date] of dates.entries()) {
    let startDateLocal = new Date(convertFromUTC(date, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + userData.dayHours.startTime)
    if (index === 0) {
      const _startDateLocal = new Date(convertFromUTC(date, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + (isClientSide() ? from.toTimeString().slice(0, 8) : convertFromUTC(from, userData.user.attributes.timezone).toTimeString().slice(0, 8)))
      startDateLocal = startDateLocal.getTime() > _startDateLocal.getTime() ? startDateLocal : _startDateLocal
    }

    let endDateLocal = new Date(convertFromUTC(date, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + userData.dayHours.endTime)
    if (index === dates.length - 1) {
      const _endDateLocal = new Date(convertFromUTC(date, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + (isClientSide() ? to.toTimeString().slice(0, 8) : convertFromUTC(to, userData.user.attributes.timezone).toTimeString().slice(0, 8)))
      endDateLocal = endDateLocal.getTime() < _endDateLocal.getTime() ? endDateLocal : _endDateLocal
    }

    const startDate = isClientSide() ? startDateLocal : convertFromLocal(startDateLocal, userData.user.attributes.timezone)
    const endDate = isClientSide() ? endDateLocal : convertFromLocal(endDateLocal, userData.user.attributes.timezone)

    const summary = await getSummary(traccarInstance, startDate, endDate, allDevices)

    counter = counter + 1
    if (!ignorePercentage) {
      console.log(`PROGRESS_PERC:${counter / dates.length * 100}`)
    }
    days.push({
      date,
      summary
    })
  }

  return days
}

exports.getRoute = getRoute
exports.getTrips = getTrips
exports.getStops = getStops
exports.getEvents = getEvents
exports.getSummary = getSummary
exports.getSummaryByDay = getSummaryByDay
exports.getAllInOne = getAllInOne
